import { ApolloError } from "@apollo/client";

export const isContraintViolationError = (error: ApolloError): boolean => error?.graphQLErrors[0]?.extensions?.code === 'constraint-violation'